export const TOTAL_ATTEMPTS_ALLOWED = 3;
export const MAX_MOBILE_WIDTH = 1000;
export const TOTAL_SCAM_EMAILS = 5;
export const TOTAL_NORMAL_EMAILS = 5;
